<template>
    <div class="d-flex justify-content-center">
        <es-container class="pt-100 mx-0">
            <es-row>
                <es-col xl="9">
                    <div class="mb-100"></div>
                    <div class="mb-300">
                        <slot />
                    </div>
                </es-col>
            </es-row>
        </es-container>
    </div>
</template>
